import styled from "styled-components";

interface FlexProps {
  justifyContent?:
    | "center"
    | "flex-start"
    | "flex-end"
    | "space-between"
    | "space-around"
    | "space-evenly";
  flexDirection?: "row" | "column" | "row-reverse" | "column-reverse";
  alignItems?: "stretch" | "center" | "flex-end" | "flex-start" | "normal";
  m?: number | string;
  mx?: number | string;
  my?: number | string;
  mt?: number | string;
  mb?: number | string;
  mr?: number | string;
  ml?: number | string;
  flexWrap?: "wrap" | "nowrap" | "wrap-reverse";
  width?: string;
  height?: string;
  flexGrow?: number;
}

export const Flex = styled.div<FlexProps>`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: ${({ alignItems }) => alignItems};
  flex-direction: ${({ flexDirection }) => flexDirection};
  margin-top: ${({ m, my, mt, theme }) => theme.spacing(m || my || mt)};
  margin-bottom: ${({ m, my, mb, theme }) => theme.spacing(m || my || mb)};
  margin-left: ${({ m, mx, ml, theme }) => theme.spacing(m || mx || ml)};
  margin-right: ${({ m, mx, mr, theme }) => theme.spacing(m || mx || mr)};
  flex-wrap: ${({ flexWrap }) => flexWrap};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  flex-grow: ${({ flexGrow }) => flexGrow};
`;

Flex.defaultProps = {
  justifyContent: "flex-start",
  flexDirection: "row",
  alignItems: "normal",
  flexWrap: "nowrap",
};
